import apolloClient from "@/apollo";
import CountryTablesProvider from "../provider/CountryTablesProvider";
import {
  SET_DATA_PERFORMANCE_TOOL_RESULT,
  SET_DATA_VULNERABILITY,
  SET_VULNERABILITY_APPLY,
  SET_VULNERABILITY_LOADING,
  SET_URL_EXPORT_VULNERABILITY,
  SET_DATA_PERFORMANCE,
} from "./CountryTablesMutationsType";

export default {
  state: {
    performance_tool_results: "[]",
    vulnerability: "[]",
    data_vulnerability_apply: "[]",
    vulnerability_loading: false,
    vulnerability_url: "",
    performance: "[]",
  },
  getters: {
    getPerformanceToolResult(state) {
      return state.performance_tool_results;
    },
    getVulnerability(state) {
      return state.vulnerability;
    },
    getDataVulnerabilityApply(state) {
      return state.data_vulnerability_apply;
    },
    getVulnerabilityLoading(state) {
      return state.vulnerability_loading;
    },
    getUrlVulnerability(state) {
      return state.vulnerability_url;
    },
    getPerformance(state) {
      return state.performance;
    },
  },
  actions: {
    setDataPerformanceToolResult({ commit }, payload) {
      apolloClient.cache.reset();
      commit(SET_DATA_PERFORMANCE_TOOL_RESULT, "[]");
      CountryTablesProvider.getDataCountryTableResult(payload).then((data) => {
        commit(
          SET_DATA_PERFORMANCE_TOOL_RESULT,
          data.data.performanceToolResult.data.replaceAll("\\", "")
        );
      });
    },
    setDataVulneravility({ commit }, payload) {
      apolloClient.cache.reset();
      commit(SET_DATA_VULNERABILITY, "[]");
      CountryTablesProvider.getDataVulnerability(payload).then((data) => {
        commit(
          SET_DATA_VULNERABILITY,
          data.data.vulnerability.data.replaceAll("\\", "")
        );
      });
    },
    setVulneravilityApply({ commit }, payload) {
      commit(SET_VULNERABILITY_LOADING, true);
      apolloClient.cache.reset();
      commit(SET_VULNERABILITY_APPLY, "[]");
      CountryTablesProvider.setVulnerabilityMutation(payload).then((data) => {
        commit(
          SET_VULNERABILITY_APPLY,
          data.data.vulnerability.data.replaceAll("\\", "")
        );
        commit(SET_VULNERABILITY_LOADING, false);
      });
    },
    exportExcelVulnerability({ commit }, payload) {
      commit(SET_URL_EXPORT_VULNERABILITY, "");
      CountryTablesProvider.ApplyExportExcel(
        payload.variables,
        payload.data
      ).then((data) => {
        commit(
          SET_URL_EXPORT_VULNERABILITY,
          data.data.exportExcelVulnerability.url
        );
      });
    },
    setPerformaceApply({ commit }, payload) {
      commit(SET_VULNERABILITY_LOADING, true);
      apolloClient.cache.reset();
      commit(SET_VULNERABILITY_APPLY, "[]");
      CountryTablesProvider.setPerformanceMutation(payload).then((data) => {
        commit(
          SET_VULNERABILITY_APPLY,
          data.data.performance.data.replaceAll("\\", "")
        );
        commit(SET_VULNERABILITY_LOADING, false);
      });
    },

    setDataPerformance({ commit }, payload) {
      apolloClient.cache.reset();
      commit(SET_DATA_PERFORMANCE, "[]");
      CountryTablesProvider.getDataPerformance(payload).then((data) => {
        commit(
          SET_DATA_PERFORMANCE,
          data.data.performance.data.replaceAll("\\", "")
        );
      });
    },

    exportExcelPerfomance({ commit }, payload) {
      commit(SET_URL_EXPORT_VULNERABILITY, "");
      CountryTablesProvider.ApplyExportExcelPerformance(
        payload.variables,
        payload.data
      ).then((data) => {
        commit(
          SET_URL_EXPORT_VULNERABILITY,
          data.data.exportExcelPerformace.url
        );
      });
    },
  },
  mutations: {
    [SET_DATA_PERFORMANCE_TOOL_RESULT](state, payload) {
      state.performance_tool_results = payload;
    },
    [SET_DATA_VULNERABILITY](state, payload) {
      state.vulnerability = payload;
    },
    [SET_DATA_PERFORMANCE](state, payload) {
      state.performance = payload;
    },
    [SET_VULNERABILITY_APPLY](state, payload) {
      state.data_vulnerability_apply = payload;
    },
    [SET_VULNERABILITY_LOADING](state, payload) {
      state.vulnerability_loading = payload;
    },
    [SET_URL_EXPORT_VULNERABILITY](state, payload) {
      state.vulnerability_url = payload;
    },
  },
};
